import { InputGroup, FormControl, Alert } from "react-bootstrap";

import { Footer } from "../../components/include/Footer";
import Title from "../../components/common/Title";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  isLoading,
  isError,
  isAuthenticated,
  isMessage,
  isData,
} from "../../redux/selectors/authSelector";
import {
  signup,
  signupClear,
  signupSuccess,
} from "../../redux/actions/authActions";
import { Link, useNavigate, useParams } from "react-router-dom";
import { message } from "../../redux/actions/toastActions";
import Logo from "../../assets/Icons/Frame 476.png";
import "../../styles/Login.scss";
import emailIcon from "../../assets/Icons/email.svg";
import lockIcon from "../../assets/Icons/lock.svg";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import userIcon from "../../assets/Icons/user.svg";
import schoolIcon from "../../assets/Icons/graduate.svg";
import phoneIcon from "../../assets/Icons/world.svg";
import signupBg from "../../assets/pst-auth-bg.png";
import logoBg from "../../assets/Icons/Frame 475.svg";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { toast } from "sonner";
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";
import axios from "axios";

const SignUp = () => {
  const flagsContext = require.context(
    "../../assets/flags",
    false,
    /\.(png|jpe?g|svg)$/,
  );

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [email, setEmail] = useState(
    process.env.NODE_ENV !== "production" ? "devadmin" : "",
  );
  const [contactNumber, setContactNumber] = useState("");
  const [password, setPassword] = useState(
    process.env.NODE_ENV !== "production" ? "123456" : "",
  );
  const [confirmPassword, setConfirmPassword] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const ALLOWED_COUNTRY_CODES = ["ke", "ug"];
  const [countries, setCountries] = useState([]);
  const { country } = useParams();

  const [selectedCountry, setSelectedCountry] = useState("KE");

  useEffect(() => {
    if (country && ALLOWED_COUNTRY_CODES.includes(country.toLowerCase())) {
      setSelectedCountry(country.toUpperCase());
    } else {
      setSelectedCountry("KE");
    }
  }, [country]);

  // Validation errors state
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    username: "",
    schoolName: "",
    email: "",
    contactNumber: "",
    password: "",
    confirmPassword: "",
    terms: "",
  });

  const loader = useSelector(isLoading);
  const Authenticated = useSelector(isAuthenticated);
  const Data = useSelector(isData);
  const loginMessage = useSelector(isMessage);
  const errorMsg = useSelector(isError);

  const dispatch = useDispatch();
  const navigate = useCountryNavigate();

  const getFlagImage = (code) => {
    try {
      return flagsContext(`./${code.toLowerCase()}.png`);
    } catch (e) {
      return null;
    }
  };

  // Validation function
  const validateForm = () => {
    const newErrors = {
      firstName: "",
      lastName: "",
      username: "",
      schoolName: "",
      email: "",
      contactNumber: "",
      password: "",
      confirmPassword: "",
      terms: "",
    };

    let isValid = true;

    if (!firstName.trim()) {
      newErrors.firstName = "First name is required";
      isValid = false;
    }

    if (!lastName.trim()) {
      newErrors.lastName = "Last name is required";
      isValid = false;
    }

    // if (!username.trim()) {
    //   newErrors.username = "Username is required";
    //   isValid = false;
    // }
    if (!username?.trim()) {
      newErrors.username = "Username is required";
    } else if (!/^(?=.*[A-Za-z])[A-Za-z0-9]+$/.test(username)) {
      newErrors.username =
        "Username must contain at letter and can include numbers.";
    }

    if (!schoolName.trim()) {
      newErrors.schoolName = "School name is required";
      isValid = false;
    }

    if (!email.trim()) {
      newErrors.email = "Email is required";
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Please enter a valid email address";
      isValid = false;
    }

    if (!contactNumber.trim()) {
      newErrors.contactNumber = "Contact number is required";
      isValid = false;
    } else if (contactNumber.length < 10) {
      newErrors.contactNumber = "Contact number must be 10 digits";
      isValid = false;
    }

    if (!password) {
      newErrors.password = "Password is required";
      isValid = false;
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
      isValid = false;
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password";
      isValid = false;
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
      isValid = false;
    }

    if (!termsAccepted) {
      newErrors.terms = "You must accept the Terms & Conditions";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const onSignUpAction = async (event) => {
    event.preventDefault();

    // Clear previous errors
    setErrors({
      firstName: "",
      lastName: "",
      username: "",
      schoolName: "",
      email: "",
      contactNumber: "",
      password: "",
      confirmPassword: "",
      terms: "",
    });

    // Validate form
    if (!validateForm()) {
      return;
    }

    const formData = {
      first_name: firstName,
      last_name: lastName,
      username,
      school_name: schoolName,
      email,
      mobile: contactNumber,
      country_code: selectedCountry,
      password,
      isAgreeTC: termsAccepted,
    };

    try {
      setLoading(true);

      const result = await Postdata(HttpService.signupUrl, formData);

      if (result?.status === 200) {
        navigate("signUp-verify", { state: { email } });
        return;
      }

      // Handle backend validation errors - show in appropriate field
      const errorMessage =
        result?.message ?? "Something went wrong. Please try again.";

      // Check if error is email-related
      if (errorMessage.toLowerCase().includes("email")) {
        setErrors((prev) => ({ ...prev, email: errorMessage }));
      } else if (errorMessage.toLowerCase().includes("username")) {
        setErrors((prev) => ({ ...prev, username: errorMessage }));
      } else if (
        errorMessage.toLowerCase().includes("mobile") ||
        errorMessage.toLowerCase().includes("phone")
      ) {
        setErrors((prev) => ({ ...prev, contactNumber: errorMessage }));
      } else {
        // Generic error - show as toast
        toast.warning(errorMessage);
      }
    } catch (e) {
      console.error("Signup error:", e);
      toast.error(e?.message ?? "Unable to sign up. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await axios.get(HttpService.school_country_show);

        if (res.status === 200 && Array.isArray(res.data.data)) {
          const filteredCountries = res.data.data.filter(
            (c) =>
              c.isActive === true &&
              ALLOWED_COUNTRY_CODES.includes(c.code.toLowerCase()),
          );

          setCountries(filteredCountries);
        }
      } catch (err) {
        console.error("Error loading countries:", err);
      }
    };

    fetchCountries();
  }, []);

  useEffect(() => {
    dispatch(signupClear());
  }, [dispatch]);

  useEffect(() => {
    if (Authenticated) {
      navigate("signUp-verify", { state: { email: email } });
    }
  }, [Authenticated]);

  return (
    <>
      <Title name="Sign Up" />
      <div className="font-fustat loginBackground" style={{ paddingTop: "3%" }}>
        <div className="absolute top-8 right-8 w-80 h-auto z-10">
          <img src={logoBg} alt="App Logo" className="w-full h-auto" />
        </div>
        <div className="container">
          <div className="row justify-items-start">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div
                className="card overflow-hidden"
                style={{ backgroundColor: "white" }}
              >
                <div className="card-body pt-0">
                  <h3 className="text-center mt-4">
                    <a href="/" className="logo logo-admin">
                      <img
                        src={Logo}
                        height="100"
                        alt="logo"
                        className="mb-4"
                        style={{ width: "220px" }}
                      />
                    </a>
                    {/* {errorMsg} */}

                    <h3>Sign Up</h3>

                    <p className="sub-title">
                      Join now to simplify your school's operations
                      <br />
                      Sign up and get started in minutes!
                    </p>
                  </h3>
                  <div
                    className="login-container"
                    style={{ maxWidth: "480px" }}
                  >
                    <form
                      className="login-form"
                      autoComplete="off"
                      onSubmit={onSignUpAction}
                    >
                      <div className="flex flex-col md:flex-row justify-between gap-2 md:gap-8">
                        <div className="w-full md:w-1/2">
                          <label className="block">
                            First Name
                            <span className="required text-red-500">*</span>
                          </label>
                          <div className="input-group">
                            <span className="icon">
                              <img
                                src={userIcon}
                                alt="user icon"
                                className="w-5 h-5"
                              />
                            </span>
                            <input
                              type="text"
                              value={firstName}
                              onChange={(e) => {
                                const onlyLetters = e.target.value.replace(
                                  /[^A-Za-z\s]/g,
                                  "",
                                );
                                setFirstName(onlyLetters);
                                if (errors.firstName) {
                                  setErrors({ ...errors, firstName: "" });
                                }
                              }}
                              placeholder="Enter First Name"
                              className="w-full text-sm md:text-base border-none focus:outline-none"
                            />
                          </div>
                          {errors.firstName && (
                            <p className="text-red-500 text-xs mt-1">
                              {errors.firstName}
                            </p>
                          )}
                        </div>
                        <div className="w-full md:w-1/2">
                          <label className="block">
                            Last Name
                            <span className="required text-red-500">*</span>
                          </label>
                          <div className="input-group">
                            <span className="icon">
                              <img
                                src={userIcon}
                                alt="user icon"
                                className="w-5 h-5"
                              />
                            </span>
                            <input
                              type="text"
                              value={lastName}
                              onChange={(e) => {
                                const onlyLetters = e.target.value.replace(
                                  /[^A-Za-z\s]/g,
                                  "",
                                );
                                setLastName(onlyLetters);
                                if (errors.lastName) {
                                  setErrors({ ...errors, lastName: "" });
                                }
                              }}
                              placeholder="Enter Last Name"
                              className="w-full text-sm md:text-base border-none focus:outline-none"
                            />
                          </div>
                          {errors.lastName && (
                            <p className="text-red-500 text-xs mt-1">
                              {errors.lastName}
                            </p>
                          )}
                        </div>
                      </div>

                      {/* Username */}
                      <label>
                        Username<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <span className="icon">
                          <img src={userIcon} alt="user icon" />
                        </span>
                        <input
                          type="text"
                          value={username}
                          onChange={(e) => {
                            setUsername(e.target.value);
                            if (errors.username) {
                              setErrors({ ...errors, username: "" });
                            }
                          }}
                          placeholder="Enter Your Username"
                        />
                      </div>
                      {errors.username && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.username}
                        </p>
                      )}

                      {/* School Name */}
                      <label>
                        School Name<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <span className="icon">
                          <img src={schoolIcon} alt="school icon" />
                        </span>
                        <input
                          type="text"
                          value={schoolName}
                          onChange={(e) => {
                            setSchoolName(e.target.value);
                            if (errors.schoolName) {
                              setErrors({ ...errors, schoolName: "" });
                            }
                          }}
                          placeholder="Enter Your School Name"
                        />
                      </div>
                      {errors.schoolName && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.schoolName}
                        </p>
                      )}

                      {/* Email ID */}
                      <label>
                        Email ID<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <span className="icon">
                          <img src={emailIcon} alt="email icon" />
                        </span>
                        <input
                          type="text"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            if (errors.email) {
                              setErrors({ ...errors, email: "" });
                            }
                          }}
                          placeholder="Enter Your Email ID"
                          autoComplete="new-email"
                        />
                      </div>
                      {errors.email && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.email}
                        </p>
                      )}

                      {/* Contact Number */}
                      <label>
                        Contact Number<span className="required">*</span>
                      </label>
                      <div className="input-group flex items-center">
                        <span className="icon flex items-center relative">
                          <select
                            value={selectedCountry}
                            onChange={(e) => setSelectedCountry(e.target.value)}
                            className="absolute inset-0 opacity-0 cursor-pointer"
                          >
                            <option value="KE">Select</option>
                            {countries.map((country) => (
                              <option key={country._id} value={country.code}>
                                {country.name}
                              </option>
                            ))}
                          </select>

                          {selectedCountry ? (
                            <img
                              src={getFlagImage(selectedCountry)}
                              alt="flag"
                              className="w-6 h-4"
                            />
                          ) : (
                            <img
                              src={phoneIcon}
                              alt="phone"
                              className="w-5 h-5"
                            />
                          )}

                          <span className="ml-1 text-xs">▾</span>
                        </span>

                        <input
                          type="tel"
                          value={contactNumber}
                          onChange={(e) => {
                            const onlyNumbers = e.target.value.replace(
                              /[^0-9]/g,
                              "",
                            );
                            setContactNumber(onlyNumbers);
                            if (errors.contactNumber) {
                              setErrors({ ...errors, contactNumber: "" });
                            }
                          }}
                          placeholder="Enter your number"
                          maxLength={10}
                          className="flex-1 bg-transparent outline-none"
                        />
                      </div>
                      {errors.contactNumber && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.contactNumber}
                        </p>
                      )}

                      {/* Password */}
                      <label>
                        Password<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <span className="icon">
                          <img src={lockIcon} alt="lock icon" />
                        </span>
                        <input
                          type={showPassword ? "text" : "password"}
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                            if (errors.password) {
                              setErrors({ ...errors, password: "" });
                            }
                          }}
                          placeholder="Enter Your Password"
                          autoComplete="new-password"
                        />
                        <span
                          className="toggle"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <IoEyeOutline className="icon" />
                          ) : (
                            <IoEyeOffOutline className="icon" />
                          )}
                        </span>
                      </div>
                      {errors.password && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.password}
                        </p>
                      )}

                      {/* Confirm Password */}
                      <label>
                        Confirm Password<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <span className="icon">
                          <img src={lockIcon} alt="lock icon" />
                        </span>
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          value={confirmPassword}
                          onChange={(e) => {
                            setConfirmPassword(e.target.value);
                            if (errors.confirmPassword) {
                              setErrors({ ...errors, confirmPassword: "" });
                            }
                          }}
                          placeholder="Enter Your Password"
                          autoComplete="new-password"
                        />
                        <span
                          className="toggle"
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                        >
                          {showConfirmPassword ? (
                            <IoEyeOutline className="icon" />
                          ) : (
                            <IoEyeOffOutline className="icon" />
                          )}
                        </span>
                      </div>
                      {errors.confirmPassword && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.confirmPassword}
                        </p>
                      )}

                      {/* Checkbox */}
                      <div className="form-check mt-2 mb-2 flex items-start">
                        <input
                          type="checkbox"
                          className="form-check-input transform scale-145 mt-2"
                          id="termsCheck"
                          checked={termsAccepted}
                          onChange={(e) => {
                            setTermsAccepted(e.target.checked);
                            if (errors.terms) {
                              setErrors({ ...errors, terms: "" });
                            }
                          }}
                        />
                        <div className="ml-1">
                          <label
                            htmlFor="termsCheck"
                            className="form-check-label mt-[6px]"
                          >
                            I agree to the{" "}
                            <a
                              href="#"
                              className="text-secondary_main font-bold"
                            >
                              Terms & Conditions
                            </a>{" "}
                            and{" "}
                            <a
                              href="#"
                              className="text-secondary_main font-bold"
                            >
                              Privacy Policy
                            </a>
                            .
                          </label>
                          {errors.terms && (
                            <p className="text-red-500 text-xs mt-1">
                              {errors.terms}
                            </p>
                          )}
                        </div>
                      </div>

                      {/* Sign Up Button */}
                      <button
                        type="submit"
                        className="sign-in-button"
                        disabled={loading}
                      >
                        {loading ? "Please wait..." : "Sign Up"}
                      </button>
                    </form>

                    <p className="text-center pt-3 font-sm">
                      Already have an Account?{" "}
                      <Link to="/" className="forgot-password">
                        Sign In
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;

// const SignUp = () => {
//   const flagsContext = require.context(
//     "../../assets/flags",
//     false,
//     /\.(png|jpe?g|svg)$/
//   );
//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [username, setUsername] = useState("");
//   const [schoolName, setSchoolName] = useState("");
//   const [email, setEmail] = useState(
//     process.env.NODE_ENV !== "production" ? "devadmin" : ""
//   );
//   const [contactNumber, setContactNumber] = useState("");
//   const [password, setPassword] = useState(
//     process.env.NODE_ENV !== "production" ? "123456" : ""
//   );
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [termsAccepted, setTermsAccepted] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const [countries, setCountries] = useState([]);
//   const [selectedCountry, setSelectedCountry] = useState("KE");

//   // const [IPAddress, setIPAddress] = useState('')
//   const loader = useSelector(isLoading);
//   const Authenticated = useSelector(isAuthenticated);
//   const Data = useSelector(isData);
//   const loginMessage = useSelector(isMessage);
//   const errorMsg = useSelector(isError);

//   const dispatch = useDispatch();
//   // const navigate = useNavigate();
//   const navigate = useCountryNavigate();

//   const getFlagImage = (code) => {
//     try {
//       return flagsContext(`./${code.toLowerCase()}.png`);
//     } catch (e) {
//       return null;
//     }
//   };

//   const onSignUpAction = async (event) => {
//     event.preventDefault();

//     // Basic validations
//     if (password !== confirmPassword) {
//       dispatch(message("Passwords do not match"));
//       return;
//     }
//     if (!termsAccepted) {
//       dispatch(message("You must accept the Terms & Conditions"));
//       return;
//     }

//     const formData = {
//       first_name: firstName,
//       last_name: lastName,
//       username,
//       school_name: schoolName,
//       email,
//       mobile: contactNumber,
//       country: selectedCountry,
//       password,
//       isAgreeTC: termsAccepted,
//     };

//     try {
//       setLoading(true);

//       const result = await Postdata(HttpService.signupUrl, formData);

//       if (result?.status === 200) {
//         navigate("signUp-verify", { state: { email } });
//         return;
//       }

//       toast.warning(
//         result?.message ?? "Something went wrong. Please try again."
//       );
//     } catch (e) {
//       console.error("Signup error:", e);
//       toast.error(e?.message ?? "Unable to sign up. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const fetchCountries = async () => {
//       try {
//         const res = await axios.get(HttpService.school_country_show);

//         if (res.status === 200 && Array.isArray(res.data.data)) {
//           const activeCountries = res.data.data.filter(
//             (c) => c.isActive === true
//           );
//           setCountries(activeCountries);
//         }
//       } catch (err) {
//         console.error("Error loading countries:", err);
//       }
//     };

//     fetchCountries();
//   }, []);
//   useEffect(() => {
//     dispatch(signupClear());
//   }, [dispatch]);

//   useEffect(() => {
//     if (Authenticated) {
//       navigate("signUp-verify", { state: { email: email } });
//       // dispatch(message(loginMessage));
//     }
//   }, [Authenticated]);

//   return (
//     <>
//       <Title name="Sign Up" />
//       {console.log("errorMsg => eeeeeeeeeee", errorMsg)}
//       <div
//         className=" font-fustat loginBackground"
//         style={{ paddingTop: "3%" }}
//       >
//         {/* <div className="h-full">
//           <img src={signupBg} className="login-background-img" alt="background" />
//         </div> */}
//         <div className="absolute top-8 right-8 w-80 h-auto z-10">
//           <img src={logoBg} alt="App Logo" className="w-full h-auto" />
//         </div>
//         <div className="container">
//           <div className="row justify-items-start">
//             <div className="col-md-8 col-lg-6 col-xl-5">
//               <div
//                 className="card overflow-hidden"
//                 style={{ backgroundColor: "white" }}
//               >
//                 <div className="card-body pt-0">
//                   <h3 className="text-center mt-4">
//                     <a href="/" className="logo logo-admin">
//                       <img
//                         src={Logo}
//                         height="100"
//                         alt="logo"
//                         className=" mb-4"
//                         style={{ width: "220px" }}
//                       />
//                     </a>
//                     {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}

//                     <h3>Sign Up</h3>

//                     <p className="sub-title">
//                       Join now to simplify your school's operations
//                       <br></br>
//                       Sign up and get started in minutes!
//                     </p>
//                   </h3>
//                   <div
//                     className="login-container "
//                     style={{ maxWidth: "480px" }}
//                   >
//                     <form
//                       className="login-form"
//                       autoComplete="off"
//                       onSubmit={onSignUpAction}
//                     >
//                       <div className="flex flex-col md:flex-row justify-between gap-2 md:gap-8">
//                         <div className="w-full md:w-1/2">
//                           <label className="block  ">
//                             First Name
//                             <span className="required text-red-500">*</span>
//                           </label>
//                           <div className="input-group ">
//                             <span className="icon ">
//                               <img
//                                 src={userIcon}
//                                 alt="user icon"
//                                 className="w-5 h-5"
//                               />
//                             </span>
//                             <input
//                               type="text"
//                               value={firstName}
//                               onChange={(e) => {
//                                 // remove anything that's not a letter or space
//                                 const onlyLetters = e.target.value.replace(
//                                   /[^A-Za-z\s]/g,
//                                   ""
//                                 );
//                                 setFirstName(onlyLetters);
//                               }}
//                               placeholder="Enter First Name"
//                               required
//                               className="w-full  text-sm md:text-base border-none focus:outline-none"
//                             />
//                           </div>
//                         </div>
//                         <div className="w-full md:w-1/2">
//                           <label className="block  ">
//                             Last Name
//                             <span className="required text-red-500">*</span>
//                           </label>
//                           <div className="input-group ">
//                             <span className="icon ">
//                               <img
//                                 src={userIcon}
//                                 alt="user icon"
//                                 className="w-5 h-5"
//                               />
//                             </span>
//                             <input
//                               type="text"
//                               value={lastName}
//                               onChange={(e) => {
//                                 // remove anything that's not a letter or space
//                                 const onlyLetters = e.target.value.replace(
//                                   /[^A-Za-z\s]/g,
//                                   ""
//                                 );
//                                 setLastName(onlyLetters);
//                               }}
//                               placeholder="Enter Last Name"
//                               required
//                               className="w-full  text-sm md:text-base border-none focus:outline-none"
//                             />
//                           </div>
//                         </div>
//                       </div>

//                       {/* Username */}
//                       <label>
//                         Username<span className="required">*</span>
//                       </label>
//                       <div className="input-group">
//                         <span className="icon">
//                           <img src={userIcon} alt="user icon" />
//                         </span>
//                         <input
//                           type="text"
//                           value={username}
//                           onChange={(e) => setUsername(e.target.value)}
//                           placeholder="Enter Your Username"
//                           required
//                         />
//                       </div>

//                       {/* School Name */}
//                       <label>
//                         School Name<span className="required">*</span>
//                       </label>
//                       <div className="input-group">
//                         <span className="icon">
//                           <img src={schoolIcon} alt="school icon" />
//                         </span>
//                         <input
//                           type="text"
//                           value={schoolName}
//                           onChange={(e) => setSchoolName(e.target.value)}
//                           placeholder="Enter Your School Name"
//                           required
//                         />
//                       </div>

//                       {/* Email ID */}
//                       <label>
//                         Email ID<span className="required">*</span>
//                       </label>
//                       <div className="input-group">
//                         <span className="icon">
//                           <img src={emailIcon} alt="email icon" />
//                         </span>
//                         <input
//                           type="email"
//                           value={email}
//                           onChange={(e) => setEmail(e.target.value)}
//                           placeholder="Enter Your Email ID"
//                           autoComplete="new-email"
//                           required
//                         />
//                       </div>

//                       {/* Contact Number */}

//                       <label>
//                         Contact Number<span className="required">*</span>
//                       </label>

//                       <div className="input-group flex items-center">
//                         {/* Country selector */}
//                         <span className="icon flex items-center relative">
//                           <select
//                             value={selectedCountry}
//                             onChange={(e) => setSelectedCountry(e.target.value)}
//                             className="absolute inset-0 opacity-0 cursor-pointer"
//                             required
//                           >
//                             <option value="KE">Select</option>
//                             {countries.map((country) => (
//                               <option key={country._id} value={country.code}>
//                                 {country.name}
//                               </option>
//                             ))}
//                           </select>

//                           {/* Flag Icon */}
//                           {selectedCountry ? (
//                             <img
//                               src={getFlagImage(selectedCountry)}
//                               alt="flag"
//                               className="w-6 h-4"
//                             />
//                           ) : (
//                             <img
//                               src={phoneIcon}
//                               alt="phone"
//                               className="w-5 h-5"
//                             />
//                           )}

//                           {/* Dropdown arrow */}
//                           <span className="ml-1 text-xs">▾</span>
//                         </span>

//                         {/* Phone input */}
//                         <input
//                           type="tel"
//                           value={contactNumber}
//                           onChange={(e) => {
//                             const onlyNumbers = e.target.value.replace(
//                               /[^0-9]/g,
//                               ""
//                             );
//                             setContactNumber(onlyNumbers);
//                           }}
//                           placeholder="Enter your number"
//                           maxLength={10}
//                           className="flex-1 bg-transparent outline-none"
//                           required
//                         />
//                       </div>

//                       {/* <label>
//                         Contact Number<span className="required">*</span>
//                       </label>
//                       <div className="input-group">
//                         <span className="icon">
//                           <img src={phoneIcon} alt="phone icon" />
//                         </span>
//                         <input
//                           type="tel"
//                           value={contactNumber}
//                           onChange={(e) => {
//                             // keep only digits
//                             const onlyNumbers = e.target.value.replace(
//                               /[^0-9]/g,
//                               ""
//                             );
//                             setContactNumber(onlyNumbers);
//                           }}
//                           placeholder="Enter Your Contact Number"
//                           maxLength={10}
//                           required
//                         />
//                       </div> */}

//                       {/* Password */}
//                       <label>
//                         Password<span className="required">*</span>
//                       </label>
//                       <div className="input-group">
//                         <span className="icon">
//                           <img src={lockIcon} alt="lock icon" />
//                         </span>
//                         <input
//                           type={showPassword ? "text" : "password"}
//                           value={password}
//                           onChange={(e) => setPassword(e.target.value)}
//                           placeholder="Enter Your Password"
//                           autoComplete="new-password"
//                           required
//                         />
//                         <span
//                           className="toggle"
//                           onClick={() => setShowPassword(!showPassword)}
//                         >
//                           {showPassword ? (
//                             <IoEyeOutline className="icon" />
//                           ) : (
//                             <IoEyeOffOutline className="icon" />
//                           )}
//                         </span>
//                       </div>

//                       {/* Confirm Password */}
//                       <label>
//                         Confirm Password<span className="required">*</span>
//                       </label>
//                       <div className="input-group">
//                         <span className="icon">
//                           <img src={lockIcon} alt="lock icon" />
//                         </span>
//                         <input
//                           type={showConfirmPassword ? "text" : "password"}
//                           value={confirmPassword}
//                           onChange={(e) => setConfirmPassword(e.target.value)}
//                           placeholder="Enter Your Password"
//                           autoComplete="new-password"
//                           required
//                         />
//                         <span
//                           className="toggle"
//                           onClick={() =>
//                             setShowConfirmPassword(!showConfirmPassword)
//                           }
//                         >
//                           {showConfirmPassword ? (
//                             <IoEyeOutline className="icon" />
//                           ) : (
//                             <IoEyeOffOutline className="icon" />
//                           )}
//                         </span>
//                       </div>
//                       {/* <div className="input-group">
//                         <span className="icon">
//                           <img src={lockIcon} alt="lock icon" />
//                         </span>
//                         <input
//                           type={showConfirmPassword ? "text" : "password"}
//                           value={confirmPassword}
//                           onChange={(e) => setConfirmPassword(e.target.value)}
//                           placeholder="Confirm Your Password"
//                           autoComplete="new-password"
//                           required
//                         />
//                         <span
//                           className="toggle"
//                           onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                         >
//                          {showPassword ? (
//                             <IoEyeOutline className="icon" />
//                           ) : (
//                             <IoEyeOffOutline className="icon" />
//                           )}
//                         </span>
//                       </div> */}

//                       {/* Checkbox */}
//                       <div className="form-check mt-2 mb-2 flex items-center">
//                         <input
//                           type="checkbox"
//                           className="form-check-input transform scale-145 mt-2"
//                           id="termsCheck"
//                           checked={termsAccepted}
//                           onChange={(e) => setTermsAccepted(e.target.checked)}
//                           required
//                         />
//                         <label
//                           htmlFor="termsCheck"
//                           className="form-check-label ml-1 mt-[6px]"
//                         >
//                           I agree to the{" "}
//                           <a href="#" className="text-secondary_main font-bold">
//                             Terms & Conditions
//                           </a>{" "}
//                           and{" "}
//                           <a href="#" className="text-secondary_main font-bold">
//                             Privacy Policy
//                           </a>
//                           .
//                         </label>
//                       </div>

//                       {/* Sign Up Button */}
//                       <button
//                         type="submit"
//                         className="sign-in-button"
//                         disabled={loading}
//                       >
//                         {loading ? "Please wait..." : "Sign Up"}
//                       </button>
//                     </form>

//                     <p className="text-center pt-3 font-sm">
//                       Already have an Account?{" "}
//                       <Link to="/" className="forgot-password">
//                         Sign In
//                       </Link>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//               {/* <div className="mt-5 text-center">
//                 <Footer />
//               </div> */}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };
